; (function ($, window, document, undefined) {

	const pluginName = 'onesignal';

	class OneSignalSDK {
		constructor(element, options) {
			this._name = pluginName;
			this._defaults = $.fn[pluginName].defaults;

			this.element = element;
			this.options = $.extend(
				true,
				{},
				this._defaults,
				JSON.parse(JSON.parse($(this.element).html().trim())),
				options
			);

			this.init();
		}

		init() {
			// console.log('OneSignalSDK');

			let OneSignal = window.OneSignal || [];

			OneSignal.push(["init", this.options]);

			OneSignal.push(function () {
				OneSignal.showHttpPrompt();
			});
		}
	}

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new OneSignalSDK(this, options));
			}
		});
	};

	$.fn[pluginName].defaults = {
		appId: JSON.parse($('#bignews__metadata').text().trim()).one_signal_app_id,
		autoRegister: false,
		notifyButton: {
			enable: true, /* Set to false to hide */
			text: {
				'tip.state.unsubscribed': 'Deseja receber nossas atualizações com nossas notificações?',
				'tip.state.subscribed': "Você já recebe nossas notificações",
				'tip.state.blocked': "Você bloqueou nossas notificações",
				'message.prenotify': 'Receba nossas notificações',
				'message.action.subscribed': "Obrigado por inscrever-se!",
				'message.action.resubscribed': "Sua incrição foi realizada",
				'message.action.unsubscribed': "Você não receberá mais nossas notificações",
				'dialog.main.title': 'Gerenciar notificações',
				'dialog.main.button.subscribe': 'QUERO RECEBER',
				'dialog.main.button.unsubscribe': 'AGORA NÃO',
				'dialog.blocked.title': 'Desbloquear notificações',
				'dialog.blocked.message': "Siga as instruções para permitir notificações:"
			},
			colors: { // Customize the colors of the main button and dialog popup button
				'circle.background': 'rgb(23,172,210)',
				'circle.foreground': 'white',
				'badge.background': 'rgb(23,172,210)',
				'badge.foreground': 'white',
				'badge.bordercolor': 'white',
				'pulse.color': 'white',
				'dialog.button.background.hovering': 'rgb(97,209,238)',
				'dialog.button.background.active': 'rgb(31,122,145)',
				'dialog.button.background': 'rgb(23,172,210)',
				'dialog.button.foreground': 'white'
			}
		},
		welcomeNotification: {
			disable: true
		},
		allowLocalhostAsSecureOrigin: false,
		promptOptions: {
			// Text that says 'wants to show notifications' by default. Limited to 75 characters.
			actionMessage: 'Deseja receber nossas atualizações com nossas notificações?',
			// Text that says 'This is an example notification'. Displays on non-mobile devices. Only one line is allowed.
			exampleNotificationTitleDesktop: 'Esse é um exemplo de notificação',
			// Text that says 'Notifications will appear on your desktop'. Displays on non-mobile devices. Only one line is allowed.
			exampleNotificationMessageDesktop: 'As notificações aparecerão na sua área de trabalho',
			// Text that says 'This is an example notification'. Displays on mobile devices with limited screen width. Only one line is allowed.
			exampleNotificationTitleMobile: 'Esse é um exemplo de notificação',
			// Text that says 'Notifications will appear on your device'. Displays on mobile devices with limited screen width. Only one line is allowed.
			exampleNotificationMessageMobile: 'As notificações aparecerão no seu dispositivo',
			//Text that says '(you can unsubscribe anytime)'.
			exampleNotificationCaption: 'Você pode cancelar as notificações quando quiser',
			// Text that says 'CONTINUE'.
			acceptButtonText: 'QUERO RECEBER',
			// Text that says 'NO THANKS'.
			cancelButtonText: 'AGORA NÃO',
			// Set to false to hide the OneSignal logo.
			showCredit: false
		}
	};

})(jQuery, window, document);
